import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useEffect } from "react";

export default function ProtectedRoute({ children }) {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const userid = queryParams.get("userid");
    if (userid) {
        localStorage.setItem("userId", userid);
    }
    const { isAuthenticated, decodedToken } = useAuth();
    const navigate = useNavigate();
    const isUserDataAddedinLocalStorage = localStorage.getItem("user");
    const isOtpVerified = localStorage.getItem("isOtpVerified");

    useEffect(() => {
        // console.log({decodedToken});
        if (!isUserDataAddedinLocalStorage) {
            navigate("/login");
        }
        else if (isUserDataAddedinLocalStorage && isOtpVerified !== "true") {
            navigate("/resend-otp");
        }
    }, [isAuthenticated]);

    if (!isUserDataAddedinLocalStorage) {
        return null; // or a loading spinner
    }

    return children;
}
